package team.platforma.multiplatform_material_extension.button.style

import androidx.compose.foundation.BorderStroke
import androidx.compose.material3.ButtonColors
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.ButtonElevation
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Shape

object AppButtonStyle {
    private var mButton : Button = Button()
    private var mFilledButton: Button? = null
    private var mOutlineButton: Button? = null
    private var mTextButton: Button? = null
    private var mTonalButton: Button? = null
    private var mElevatedButton: Button? = null

    @Composable
    fun define(
        button: Button = Button(),
        filledButton: Button? = null,
        outlineButton: Button? = null,
        textButton: Button? = null,
        tonalButton: Button? = null,
        elevatedButton: Button? = null
    ) {
        mButton = button
        mFilledButton = filledButton
        mOutlineButton = outlineButton
        mTextButton = textButton
        mTonalButton = tonalButton
        mElevatedButton = elevatedButton
    }


    data class Button(
        val shape: Shape? = null,
        val colors: ButtonColors? = null,
        val elevation: ButtonElevation? = null,
        val border: BorderStroke? = null
    )

    data class FilledButton(
        val shape: Shape,
        val colors: ButtonColors,
        val elevation: ButtonElevation,
        val border: BorderStroke?
    )
    @Composable
    fun filledButton(): FilledButton {
        return FilledButton(
            shape = mFilledButton?.shape ?: mButton.shape ?: ButtonDefaults.shape,
            colors = mFilledButton?.colors ?: mButton.colors ?: ButtonDefaults.buttonColors(),
            elevation = mFilledButton?.elevation ?: mButton.elevation ?: ButtonDefaults.buttonElevation(),
            border = mFilledButton?.border ?: mButton.border
        )
    }


    data class OutlineButton(
        val shape: Shape,
        val colors: ButtonColors,
        val elevation: ButtonElevation?,
        val border: BorderStroke
    )
    @Composable
    fun outlineButton(): OutlineButton {
        return OutlineButton(
            shape = mOutlineButton?.shape ?: mButton.shape ?: ButtonDefaults.outlinedShape,
            colors = mOutlineButton?.colors ?: mButton.colors ?:  ButtonDefaults.outlinedButtonColors(),
            elevation = mOutlineButton?.elevation ?: mButton.elevation ,
            border = mOutlineButton?.border ?: mButton.border ?: ButtonDefaults.outlinedButtonBorder(true)
        )
    }

    data class TextButton(
        val shape: Shape,
        val colors: ButtonColors,
        val elevation: ButtonElevation?,
        val border: BorderStroke?
    )
    @Composable
    fun textButton(): TextButton {
        return TextButton(
            shape = mTextButton?.shape ?: mButton.shape ?: ButtonDefaults.textShape,
            colors = mTextButton?.colors ?: mButton.colors ?: ButtonDefaults.textButtonColors(),
            elevation = mTextButton?.elevation ?: mButton.elevation ,
            border = mTextButton?.border ?: mButton.border
        )
    }

    data class TonalButton(
        val shape: Shape,
        val colors: ButtonColors,
        val elevation: ButtonElevation,
        val border: BorderStroke?
    )
    @Composable
    fun tonalButton(): TonalButton {
        return TonalButton(
            shape = mTonalButton?.shape ?: mButton.shape ?: ButtonDefaults.filledTonalShape,
            colors = mTonalButton?.colors ?: mButton.colors ?: ButtonDefaults.filledTonalButtonColors(),
            elevation = mTonalButton?.elevation ?: mButton.elevation ?: ButtonDefaults.filledTonalButtonElevation(),
            border = mTonalButton?.border ?: mButton.border
        )
    }

    data class ElevatedButton(
        val shape: Shape,
        val colors: ButtonColors,
        val elevation: ButtonElevation,
        val border: BorderStroke?
    )
    @Composable
    fun elevatedButton(): ElevatedButton {
        return ElevatedButton(
            shape = mElevatedButton?.shape ?: mButton.shape ?: ButtonDefaults.elevatedShape,
            colors = mElevatedButton?.colors ?: mButton.colors ?: ButtonDefaults.elevatedButtonColors(),
            elevation = mElevatedButton?.elevation ?: mButton.elevation ?: ButtonDefaults.elevatedButtonElevation(),
            border = mElevatedButton?.border ?: mButton.border
        )
    }


}